import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA — rejestracja service workera dla wsparcia „Install App" na Androidzie,
// fallbacku offline i cache'u statyków. Sam SW jest skopiowany przez Vite
// z `public/sw.js` do roota buildu. Wyłączamy w dev mode, żeby nie ciastkować
// hot-reloadu.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* ignore — SW jest dobrowolny dodatek, brak rejestracji nie psuje aplikacji. */
    });
  });
}
